export default {
    actions: {
        getModels(ctx, data) {
            axios
                .get(data.path + '/productModels')
                .then(response => {
                    const models = response.data;

                    ctx.commit('updateModels', models)
                })
        },
        getModelProducts(ctx, data) {
            axios
                .get(data.path + `/productModels/${data.id}`)
                .then(response => {
                    const products = response.data;

                    ctx.commit('updateProducts', products.rel_prods)
                })
        },
        getModel(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(data.path + `/getModelCatsSlug/${data.slug}`)
                    .then(response => {
                        ctx.commit('updateModel', response.data);
                        ctx.commit('updateCategories', response.data.rel_cats_quantity);
                        resolve(response);
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        getStockModel(ctx, data) {
            axios
                .get(data.path + `/showWithSlugs/${data.slug}`)
                .then(response => {
                    ctx.commit('updateStockModel', response.data);
                    ctx.commit('updateStockProducts', response.data.rel_prods);
                })
        }
    },
    state: {
        models: [],
        model: null,
        stockModel: null,
        stockProducts: [],
        categories: [],
        products: []
    },
    mutations: {
        updateModels(state, models) {
            state.models = models
        },
        updateProducts(state, products) {
            state.products = products
        },
        updateModel(state, model) {
            state.model = model;
        },
        updateCategories(state, categories) {
            state.categories = categories
        },
        updateStockModel(state, model) {
            state.stockModel = model
        },
        updateStockProducts(state, products) {
            state.stockProducts = products
        }
    },
    getters: {
        allModels(state) {
            return state.models
        },
        getCurrentModel(state) {
            return state.model
        },
        getRelCategories(state) {
            return state.categories;
        },
        stockModel(state) {
            return state.stockModel;
        },
        getProducts(state) {
            return state.stockProducts;
        },
        allModelProducts(state) {
            return state.products;
        },
    }
}
